export const CouponTags = {
  1: 'Balans artımı',
  2: 'Sifariş xidmətində əlavə faiz',
  3: 'Çatdırılma xidmətinə endirim',
  4: 'Kuryer xidmətinə endirim',
};
